// react
import React from 'react'

// components
import { Dialog3 as Dialog } from '@st-operations/uikit/src/v1/index.js'
import Header from '_components/header/index.jsx'
import NewEntityDialog from '_components/new-entity-dialog/index.jsx'
import ListView from '_components/list-view/index.jsx'

class ContentRulesPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      modalOpen: false,
    }
  }

  toggleModal = () => {
    this.setState((prevState) => ({
      modalOpen: !prevState.modalOpen,
    }))
  }

  render() {
    let { modalOpen } = this.state

    return (
      <div id="content-rules-page">
        <Header
          title="Content Rules"
          actions={[
            {
              children: 'Create New Content Rule',
              onClick: this.toggleModal,
            },
          ]}
        />
        <ListView
          columns={[
            {
              key: 'name',
              link: '/content-rules/:_id',
              sortable: true,
            },
            {
              key: 'actions',
              name: 'Actions',
            },
            {
              format: 'date',
              key: 'created_at',
              name: 'Created At',
              sortable: true,
            },
          ]}
          entities="content-rules"
          fields={['name', 'created_at', 'actions']}
          filters={[]}
          searchable={true}
          sort_key={'name'}
          sort_dir={1}
        />
        <Dialog open={modalOpen} close={this.toggleModal}>
          <NewEntityDialog
            close={this.toggleModal}
            entities="content-rules"
            title="Enter a name for your new Content Rule"
          />
        </Dialog>
      </div>
    )
  }
}

// export
export default ContentRulesPage
